<template>
    <div class="page-container">
        <div class="lang-img-container">
            <div class="selected-lang-row" @click="onLangClicked">
                <img class="lang-img" :src="this.currentSelectedLang" alt="hk">
                <img class="lang-img-arrow" src="../images/lang/arrow_down.svg" alt="arrow down">
            </div>
            <div class="lang-menu" v-if="this.showLangMenu === true">
                <div class="menu-lang-row" @click="onLangSelected('EN', en)">
                    <img class="lang-img" :src="en" alt="en">
                </div>
                <div class="menu-lang-row" @click="onLangSelected('CN', hk)">
                    <img class="lang-img" :src="hk" alt="hk">
                </div>
                <div class="menu-lang-row" @click="onLangSelected('JP', jp)">
                    <img class="lang-img" :src="jp" alt="jp">
                </div>
                <div class="menu-lang-row" @click="onLangSelected('KR', kr)">
                    <img class="lang-img" :src="kr" alt="kr">
                </div>
                <div class="menu-lang-row" @click="onLangSelected('VN', vn)">
                    <img class="lang-img" :src="vn" alt="vn">
                </div>
            </div>
        </div>

        <img class="home-menu" src="../images/home/home_menu.svg" alt="menu" @click="openMenu">
        <img class="home-bg1" src="../images/home/home_bg.webp" alt="home bg">
        <!--        <img class="home-bg2" src="../images/home/home_bg2.webp" alt="home bg">-->
        <!--        <img class="home-bg3" src="../images/home/home_bg3.webp" alt="home bg">-->
        <div class="home-fac-container">
            <img class="home-logo" src="../images/home/home_logo.svg" alt="home logo">
            <img class="home-fac" src="../images/home/fac.svg" alt="fac">
            <div class="home-fac-text">{{ this.localize('娱乐经济的能量核心') }}</div>
            <div class="home-fac-text-en">The core of the entertainment economy</div>
        </div>

    </div>

    <Teleport to="body">
        <transition name="slide-right">
            <MenuComponent v-if="this.showMenu === true" @close="onMenuClose"></MenuComponent>
        </transition>
    </Teleport>
</template>
<script>

import MenuComponent from "@/components/MenuComponent.vue";
import hk from '@/images/lang/hk.svg'
import jp from '@/images/lang/jp.svg'
import kr from '@/images/lang/kr.svg'
import en from '@/images/lang/en.svg'
import vn from '@/images/lang/vn.svg'
import {getLanguageStore} from "@/lang/langStore";

export default {
    name: 'HomePage',
    computed: {
        en() {
            return en
        },
        hk() {
            return hk
        },
        jp() {
            return jp
        },
        kr() {
            return kr
        },
        vn() {
            return vn
        }
    },
    components: {MenuComponent},
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            showMenu: false,
            currentSelectedLang: hk,
            showLangMenu: false
        }
    },
    methods: {
        onMenuClose() {
            this.showMenu = false
        },
        openMenu() {
            this.showMenu = true
        },
        onLangClicked() {
            this.showLangMenu = !this.showLangMenu
        },
        onLangSelected(code, lang) {
            this.currentSelectedLang = lang
            this.showLangMenu = false
            getLanguageStore().setLanguage(code)
        }
    }
}
</script>

<style scoped>
.page-container {
    overflow-y: hidden;
}

.home-menu {
    width: 2.4em;
    position: absolute;
    top: 2em;
    right: 2em;
    box-sizing: border-box;
}

.home-logo {
    width: 22em;
    z-index: 9;
    margin-bottom: 4em;
}

.home-bg1 {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0;
    z-index: 8;
    opacity: 0.4;
}

.home-bg2 {
    width: 110%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0;
    z-index: 7;
    opacity: 0.4;
}

.home-bg3 {
    width: 110%;
    position: absolute;
    bottom: -20em;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0;
    z-index: 6;
}

.home-fac {
    width: 8em;
}

.home-fac-container {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    bottom: 26em;
    z-index: 8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
}

.home-fac-text {
    font-size: 3em;
    font-weight: bold;
    color: #0CFC3D;
    padding: 0 1em;
    box-sizing: border-box;
}

.home-fac-text-en {
    font-size: 1.2em;
    font-weight: bold;
    color: #ffffff;
}

.lang-img {
    width: 3em;
}

.lang-img-container {
    left: 2em;
    top: 2em;
    position: absolute;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    z-index: 10;
}

.selected-lang-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.4em;
}

.lang-menu{
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 1em;
    padding: 1em 0;
    box-sizing: border-box;
}
.menu-lang-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1em;
}

.lang-img-arrow {
    width: 1.6em;
}

.lang-text{
    font-size: 1.6em;
    color: #ffffff;
}
</style>